<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label v-if="label" :for="name">{{ label }}</label>
    <select type="text"
            @change="updateValue($event.target.value)"
            :name="name"
            :required="required"
            :disabled="disabled"
            class="form-control"
            autocomplete="address-level1"
    >
      <option v-if="placeholder" value="">{{ placeholder }}</option>
      <option v-if="states"
              v-for="state in states"
              :value="state.id"
              :selected="value == state.id"
      >
        {{ state.initials }}
      </option>
    </select>
    <span v-if="error" class="help-block" v-html="error"></span>
  </div>
</template>

<script>
  export default{
    name: 'InputStates',
    props: ['name', 'value', 'required', 'label', 'error'],
    data () {
      return {
        placeholder: '- -',
        states: [
          {'id': 1, 'country_id': 1, 'name': 'Acre', 'initials': 'AC'},
          {'id': 2, 'country_id': 1, 'name': 'Alagoas', 'initials': 'AL'},
          {'id': 3, 'country_id': 1, 'name': 'Amapá', 'initials': 'AP'},
          {'id': 4, 'country_id': 1, 'name': 'Amazonas', 'initials': 'AM'},
          {'id': 5, 'country_id': 1, 'name': 'Bahia', 'initials': 'BA'},
          {'id': 6, 'country_id': 1, 'name': 'Ceará', 'initials': 'CE'},
          {'id': 7, 'country_id': 1, 'name': 'Distrito Federal', 'initials': 'DF'},
          {'id': 8, 'country_id': 1, 'name': 'Espírito Santo', 'initials': 'ES'},
          {'id': 9, 'country_id': 1, 'name': 'Goiás', 'initials': 'GO'},
          {'id': 10, 'country_id': 1, 'name': 'Maranhão', 'initials': 'MA'},
          {'id': 11, 'country_id': 1, 'name': 'Mato Grosso', 'initials': 'MT'},
          {'id': 12, 'country_id': 1, 'name': 'Mato Grosso do Sul', 'initials': 'MS'},
          {'id': 13, 'country_id': 1, 'name': 'Minas Gerais', 'initials': 'MG'},
          {'id': 14, 'country_id': 1, 'name': 'Pará', 'initials': 'PA'},
          {'id': 15, 'country_id': 1, 'name': 'Paraíba', 'initials': 'PB'},
          {'id': 16, 'country_id': 1, 'name': 'Paraná', 'initials': 'PR'},
          {'id': 17, 'country_id': 1, 'name': 'Pernambuco', 'initials': 'PE'},
          {'id': 18, 'country_id': 1, 'name': 'Piauí', 'initials': 'PI'},
          {'id': 19, 'country_id': 1, 'name': 'Rio de Janeiro', 'initials': 'RJ'},
          {'id': 20, 'country_id': 1, 'name': 'Rio Grande do Norte', 'initials': 'RN'},
          {'id': 21, 'country_id': 1, 'name': 'Rio Grande do Sul', 'initials': 'RS'},
          {'id': 22, 'country_id': 1, 'name': 'Rondônia', 'initials': 'RO'},
          {'id': 23, 'country_id': 1, 'name': 'Roraima', 'initials': 'RR'},
          {'id': 24, 'country_id': 1, 'name': 'Santa Catarina', 'initials': 'SC'},
          {'id': 25, 'country_id': 1, 'name': 'São Paulo', 'initials': 'SP'},
          {'id': 26, 'country_id': 1, 'name': 'Sergipe', 'initials': 'SE'},
          {'id': 27, 'country_id': 1, 'name': 'Tocantins', 'initials': 'TO'}
        ]
      }
    },
    methods: {
      updateValue (value) {
        this.$emit('input', value)
      }
    }
    /*
    asyncComputed: {
      states: {
        get () {
          this.placeholder = 'Carregando...'
          return this.$http.get('states?country_id=1')
          .then((response) => {
            this.placeholder = 'Selecione'
            return response.data.data
          }, () => false)
        },
        default: false
      }
    }
    */
  }
</script>


// WEBPACK FOOTER //
// InputStates.vue?007c9d70